import { render, staticRenderFns } from "./card.vue?vue&type=template&id=6642b868&scoped=true"
import script from "./card.vue?vue&type=script&setup=true&lang=js"
export * from "./card.vue?vue&type=script&setup=true&lang=js"
import style0 from "./card.vue?vue&type=style&index=0&id=6642b868&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6642b868",
  null
  
)

export default component.exports